export const SEARCH_INPUT_KEYWORD = 'SEARCH/INPUT/KEYWORD'

export const SEARCH_STATUS_IDLE = 'SEARCH/STATUS/IDLE'
export const SEARCH_STATUS_PROCESSING = 'SEARCH/STATUS/PROCESSING'
export const SEARCH_STATUS_SUCCESS = 'SEARCH/STATUS/SUCCESS'
export const SEARCH_STATUS_FAILED = 'SEARCH/STATUS/FAILED'
